import { render, staticRenderFns } from "./TrackingInitiativeComp.vue?vue&type=template&id=401f141c&scoped=true&"
import script from "./TrackingInitiativeComp.vue?vue&type=script&lang=ts&"
export * from "./TrackingInitiativeComp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401f141c",
  null
  
)

export default component.exports